import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import { dateTimeReportFormatter } from "../../fomatters/DateFormatter";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const statusFormatter = (value) => {
  switch (value) {
    case "E":
      return "Enabled";
    case "D":
      return "Disabled";
    default:
      return value;
  }
};

const startDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function PlayerListing() {
  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [signUpIp, setSignUpIp] = useState("");
  const onSignUpIpChanged = useCallback(
    (event) => setSignUpIp(event.target.value),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [office, setOffice] = useState("");
  const onOfficeChanged = useCallback((o) => setOffice(o), []);
  const { values: offices } = useDataFormatterHook({
    addEmpty: true,
    value: "officeName",
    text: "officeName",
    path: `/Player/Office_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [profile, setProfile] = useState("");
  const onProfileChanged = useCallback((p) => setProfile(p), []);
  const { values: profiles } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetPlayerProfile`,
  });

  const [limitProfile, setLimitProfile] = useState("");
  const onLimitProfileChanged = useCallback((lp) => setLimitProfile(lp), []);
  const { values: limitProfiles } = useDataFormatterHook({
    addEmpty: true,
    value: "profileName",
    text: "profileName",
    path: `/Player/GetPlayerProfileLimits`,
  });

  const [source, setSource] = useState("");
  const onSourceChanged = useCallback((s) => setSource(s), []);
  const { values: sources } = useDataFormatterHook({
    addEmpty: true,
    value: "sourceName",
    text: "sourceName",
    path: `/Player/Source_GetList`,
  });

  const [currency, setCurrency] = useState("");
  const onCurrencyChanged = useCallback((c) => setCurrency(c), []);
  const { values: currencies } = useDataFormatterHook({
    addEmpty: true,
    value: "currency",
    text: "currency",
    path: `/Agent/Currency_GetList`,
  });

  const [activeSince, setActiveSince] = useState(false);
  const onActiveSinceChange = useCallback(
    (event) => setActiveSince(event.target.checked),
    []
  );

  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [status, setStatus] = useState(0);
  const onStatusChange = useCallback(
    (event) => setStatus(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Office"
          name="name"
          data={offices}
          placeholder="DataFormatter"
          setSelectValue={onOfficeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile"
          name="name"
          data={profiles}
          placeholder="DataFormatter"
          setSelectValue={onProfileChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Profile Limits"
          name="name"
          data={limitProfiles}
          placeholder="DataFormatter"
          setSelectValue={onLimitProfileChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Source"
          name="name"
          data={sources}
          placeholder="DataFormatter"
          setSelectValue={onSourceChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Sign Up IP"
          type="text"
          value={signUpIp}
          size="small"
          onChange={onSignUpIpChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Currency"
          name="name"
          data={currencies}
          placeholder="DataFormatter"
          setSelectValue={onCurrencyChanged}
          startValue={""}
        />
        <SubGroup
          title="Active Since"
          className="grid grid-cols-1 col-span-2 p-4"
        >
          <div className="flex">
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  checked={activeSince}
                  onChange={onActiveSinceChange}
                  color="primary"
                />
              }
              label="All"
            />
            <TextField
              disabled={!activeSince}
              className="flex-1"
              required
              variant="outlined"
              id="gameDateTime"
              label="From"
              type="date"
              value={startDate}
              size="small"
              onChange={onStartDateChange}
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </SubGroup>
        <div>
          <SubGroup title="Players Selection">
            <FormControl component="fieldset">
              <RadioGroup label value={status} onChange={onStatusChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Active"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Inactive"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Player Listing Report"
        getUrl={() => "/Reports/Report_Player_Listing_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          Book: book,
          Grouping: group,
          Office: office,
          LineType: lineType,
          Profile: profile,
          ProfileLimits: limitProfile,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          Distributor: distributor,
          Source: source,
          SignUpIP: signUpIp,
          Currency: currency,
          ActiveSince: 0,
          StartDate: "",
          Status: 0,
        })}
        getTotals={(data) => ({
          player: "Totals",
          currentBalance: data.reduce(
            (acc, item) => acc + item.currentBalance,
            0
          ),
          amountAtRisk: data.reduce((acc, item) => acc + item.amountAtRisk, 0),
          availBalance: data.reduce((acc, item) => acc + item.availBalance, 0),
        })}
      >
        {/* REAL COLUMNS */}
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="name">
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="profileName">
          Profile
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="description">
          Line Type
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="status"
          dataFormat={statusFormatter}
        >
          Status
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="currency">
          Currency
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="lastWager"
          dataFormat={dateTimeReportFormatter}
        >
          Last Wager
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="creditLimit"
          dataFormat={decimalInvertedReportFormatter}
        >
          Credit Limit
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="maxWager"
          dataFormat={decimalInvertedReportFormatter}
        >
          Max Wager
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="currentBalance"
          dataFormat={decimalInvertedReportFormatter}
        >
          Balance
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="amountAtRisk"
          dataFormat={decimalInvertedReportFormatter}
        >
          At Risk
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="availBalance"
          dataFormat={decimalInvertedReportFormatter}
        >
          Available
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="signUpIP">
          Sign Up IP
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default PlayerListing;
